import { useContext, useMemo } from 'react'

import { AnalyticsContext } from '@/core/analytics'

export const useSelectTabEvent = ({ itemId }: { itemId?: string } = {}) => {
  const { selectTabEvent } = useContext(AnalyticsContext)
  return useMemo(() => selectTabEvent(itemId), [itemId, selectTabEvent])
}
